import { ReactNode, RefObject } from "react";

import formStyles from "../FormStyles/forms.module.css";

interface IFormSendFeedback {
  formSendRef: RefObject<any>;
  formErrorFeedback: ReactNode;
  formSuccessFeedback: ReactNode;
  showErrorFeedback: boolean;
  showSuccessFeedback: boolean;
}

export const FormSendFeedback = ({
  formSendRef,
  formErrorFeedback,
  formSuccessFeedback,
  showErrorFeedback,
  showSuccessFeedback,
}: IFormSendFeedback) => {
  return (
    <div
      aria-live="polite"
      className={`${
        showSuccessFeedback || showErrorFeedback ? formStyles.formFeedbackVisible : ""
      }`}
      ref={formSendRef}
      tabIndex={-1}
      data-temp-keep-index
      id="formSendFeedback"
    >
      {showSuccessFeedback && formSuccessFeedback}
      {showErrorFeedback && formErrorFeedback}
    </div>
  );
};
